import _ from 'lodash'
import vm from '../main'
import { httpClient as http } from '../services'

const internals = {}

internals.addPrimaryTrip = primaryTrip => {
  // primaryTrip = Object.assign({}, primaryTrip)

  const promises = []
  return http
    .post('/trip/primary-trip/create', {
      caId: primaryTrip.caId,
      cdId: primaryTrip.cdId,
      driverId: primaryTrip.driverId,
      helperId: primaryTrip.helperId,
      vehicleId: primaryTrip.vehicleId,
      endLoc: primaryTrip.endLoc,
      tripStatus: primaryTrip.tripStatus,
      scheduleTime: primaryTrip.scheduleTime,
      trackBy: primaryTrip.trackBy,
      collectionDataInfo: primaryTrip.collectionDataInfo,
      // isDeleted: primaryTrip,
      cityId: primaryTrip.cityId,
      userId: primaryTrip.userId,
    })
    .then(result => {
        primaryTrip = result.data
      return result
    })
    .catch(error => {
      console.error('authService.inviteUser-error:\n', error)
      throw error
    })
}


internals.updatePrimaryTrip = primaryTrip => {
  // primaryTrip = Object.assign({}, primaryTrip)
  const promises = []
  return http
    .put('/trip/primary-trip/update', {
      caId: primaryTrip.caId,
      cdId: primaryTrip.cdId,
      driverId: primaryTrip.driverId,
      helperId: primaryTrip.helperId,
      vehicleId: primaryTrip.vehicleId,
      endLoc: primaryTrip.endLoc,
      tripStatus: primaryTrip.tripStatus,
      scheduleTime: primaryTrip.scheduleTime,
      collectionDataInfo: primaryTrip.collectionDataInfo,
      // isDeleted: primaryTrip,
      status: primaryTrip.status,
      cityId: primaryTrip.cityId,
      userId: primaryTrip.userId,
      trackBy: primaryTrip.trackBy,
      _id: primaryTrip._id,
    })
    .then(result => {
        primaryTrip = result.data
      return result
    })
    .catch(error => {
      console.error('authService.inviteUser-error:\n', error)
      throw error
    })
}


internals.getById = id => {
  return http
    .get(`/trip/primary-trip/${id}`)
    .then(response => {        
      return response
    })
    .catch(error => {
      console.error('primaryTripService-error:\n', error)
      throw error
    })
}



internals.getList = params => {
 
  let parameters = `?page=${params.page}&limit=${params.limit}`;
  if(params.cityIds){
    parameters += `&cityIds=${params.cityIds}`;
  }
  if(params.startLoc){
    parameters += `&startLocations=${params.startLoc}`;
  }
  if(params.endLoc ){
    parameters += `&endLocations=${params.endLoc }`;
  }
  if(params.startDate){
    parameters += `&startDate=${params.startDate}`;
    parameters += `&endDate=${params.endDate}`;
  }
  if(params.sortBy){
    parameters += `&sortBy=${params.sortBy}`;
    parameters += `&sortOrder=${params.sortOrder}`;
  }
  if(params.searchString){
    parameters += `&searchString=${params.searchString}`;
  }
  if(parameters.status){
    parameters += `&status=${params.status}`;
  }
  if(params.tripStatus){
    parameters += `&status=${params.tripStatus}`;
  }
  if(params.driverId){
    parameters += `&driverId=${params.driverId}`;
  }
  return http
    .get(`/trip/primary-trip${parameters}`)
    .then(response => {        
      return response
    })
    .catch(error => {
      console.error('primaryTripService-error:\n', error)
      throw error
    })
}

internals.getListDate = params => {
  let parameters = `?page=${params.page}&limit=${params.limit}&endDate=${params.endDate}&startDate=${params.startDate}`;
  if(params.cityIds){
    parameters += `&cityIds=${params.cityIds}`;
  }
  if(params.startLoc){
    parameters += `&startLocations=${params.startLoc}`;
  }
  if(params.endLoc ){
    parameters += `&endLocations=${params.endLoc}`;
  }
  return http
    .get(`/trip/primary-trip${parameters}`)
    .then(response => {        
      return response
    })
    .catch(error => {
      console.error('primaryTripService-error:\n', error)
      throw error
    })
}

internals.getWasteCollectionAreaList = Id => {
    return http
      .get(`/waste-collection-area-list?cityId=${Id}`)
      .then(response => {        
        return response
      })
      .catch(error => {
        console.error('primaryTripService-error:\n', error)
        throw error
      })
  }


internals.getWasteDivisionsListById = Id => {
  return http
    .get(`/waste-divisions/by-collection-id/for-trip?_id=${Id}`)
    .then(response => {      
      return response
    })
    .catch(error => {
      console.error('primaryTripService-error:\n', error)
      throw error
    })
}

internals.getLineAndTowerByDivisionsId = data => {
    return http
      .post(`/line-tower/byId`,{
        _ids : data
      })
      .then(response => {      
        return response
      })
      .catch(error => {
        console.error('primaryTripService-error:\n', error)
        throw error
      })
  }


  internals.helperList = Id => {
    return http
      .get(`/register/helper/list?cityId=${Id}`)
      .then(response => {      
        return response
      })
      .catch(error => {
        console.error('primaryTripService-error:\n', error)
        throw error
      })
  }

  internals.driverList = Id => {
    return http
      .get(`/register/driver/list?cityId=${Id}`)
      .then(response => {      
        return response
      })
      .catch(error => {
        console.error('primaryTripService-error:\n', error)
        throw error
      })
  }

  internals.vehicleList = Id => {
    return http
      .get(`/vehicle/list/number?cityId=${Id}`)
      .then(response => {      
        return response
      })
      .catch(error => {
        console.error('primaryTripService-error:\n', error)
        throw error
      })
  }


  internals.getEndLocations = Id => {
    return http
      .get(`/transport-dumyard-segregation/list?cityId=${Id}`)
      .then(response => {        
        return response
      })
      .catch(error => {
        console.error('primaryTripService-error:\n', error)
        throw error
      })
  }

  internals.getEndLocationsAreas = Id => {
    return http    
      .get(`/transport-dumyard-segregation-area/list?areaId=${Id}`)
      .then(response => {        
        return response
      })
      .catch(error => {
        console.error('primaryTripService-error:\n', error)
        throw error
      })
  }


  internals.getcdDetails = params => {
    let parameters = `page=${params.page}&limit=${params.limit}&divisionId=${params._id}&tripId=${params.tripId}`;
    if(params.sortBy){
      parameters += `&sortBy=${params.sortBy}`;
      parameters += `&sortOrder=${params.sortOrder}`;
    }
    if(params.searchString){
      parameters += `&searchString=${params.searchString}`;
    }
    if(parameters.status){
      parameters += `&status=${params.status}`;
    }
    return http    
      .get(`/trip/primary-trip/driver/collection-details-division-id?${parameters}`)
      
      .then(response => {        
        return response
      })
      .catch(error => {
        console.error('primaryTripService-error:\n', error)
        throw error
      })
  }

  internals.getcdList = params => {
    let parameters = `page=${params.page}&limit=${params.limit}&_id=${params.id}`;
    if(params.sortBy){
      parameters += `&sortBy=${params.sortBy}`;
      parameters += `&sortOrder=${params.sortOrder}`;
    }
    if(params.searchString){
      parameters += `&searchString=${params.searchString}`;
    }
    if(parameters.status){
      parameters += `&status=${params.status}`;
    }
    return http    
      .get(`/trip/primary-trip/driver/all-collection-details?${parameters}`)
      
      .then(response => {        
        return response
      })
      .catch(error => {
        console.error('primaryTripService-error:\n', error)
        throw error
      })
  }

  internals.getLineList = params => {
    let parameters ;
    if(params.tripId){
      parameters = `tripId=${params.tripId}`;
    }
    if(params.cdId){
      parameters += `&cdId=${params.cdId}`;
    }
    return http    
      .get(`/trip/primary-trip/list/uncompleted-house-line-tower?${parameters}`)      
      .then(response => {        
        return response
      })
      .catch(error => {
        console.error('primaryTripService-error:\n', error)
        throw error
      })
  }

  internals.updateLineList = data => { 
    let parameters ;
    if(data.tripId){
      parameters = `tripId=${data.tripId}`;
    }
    if(data.cdaIds){
      parameters += `&cdaIds=${data.cdaIds}`;
    }
    if(data.dateTime){
      parameters += `&dateTime=${data.dateTime}`;
    }
    return http
      .put(`/trip/primary-trip/list/uncompleted-house-line-tower?${parameters}`)
      .then(result => {
        return result
      })
      .catch(error => {
        console.error('updateHouseStatus.service-error:\n', error)
        throw error
      })
  }

  internals.deleteTrip = Id => {
    return http
      .delete(`/trip/primary-trip/${Id}`)
      .then(response => {        
        return response
      })
      .catch(error => {
        console.error('primaryTripService-error:\n', error)
        throw error
      })
  }
  internals.startTrip = Id => {
    debugger;
    return http
      .post(`/trip/gohead-driver/start-trip`,Id)
      .then(response => {
        return response
      })
      .catch(error => {
        console.error('primaryTripService-error:\n', error)
        throw error
      })
  }

  internals.endTrips = primaryTrip => {
  
  
    const promises = []
    return http
      .post('/trip/gohead-driver/end-trip-from-admin', {
        _id: primaryTrip._id,
        reason: primaryTrip.reason
        
      })
      .then(result => {
          primaryTrip = result.data
        return result
      })
      .catch(error => {
        console.error('authService.inviteUser-error:\n', error)
        throw error
      })
  }
  internals.updateHouseStatus = primaryTrip => { 
    return http
      .put('/trip/primary-trip/update/primary-trip-tower-line-collection-status', {
        collectedOn:primaryTrip.collectedOn,
        collectedStatus: primaryTrip.collectedStatus,
        tripId: primaryTrip.tripId,
        _id: primaryTrip._id
      })
      .then(result => {
          primaryTrip = result.data
        return result
      })
      .catch(error => {
        console.error('updateHouseStatus.service-error:\n', error)
        throw error
      })
  }
  


export default internals



// WEBPACK FOOTER //
// ./src/services/primarytrip.service.js